import React from "react";

import { connect } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { bindActionCreators } from "redux";
import "./modal.css";

class ModalActivity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.modalState
      // loading: false
    };

    this.toggle = this.toggle.bind(this);
    this.action = this.action.bind(this);
  }

  action() {
    this.setState({
      // loading: true
    });

    this.props.toggleModal();
    this.setState({
      // loading: false
    });
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  render() {
    return (
      <div>
        <Modal
          size={this.props.size}
          isOpen={this.props.modalState}
          toggle={this.props.toggleModal}
          className={this.props.className}
          backdrop={this.props.backdrop}
          onClosed={this.props.onClose}
        >
          <ModalHeader toggle={this.props.toggleModal}>
            {this.props.title}
          </ModalHeader>
          <ModalBody>{this.props.children}</ModalBody>
          {this.props.noFooter ? (
            ""
          ) : (
            <ModalFooter>
              <Button color="primary" onClick={this.action}>
                Enviar
              </Button>
            </ModalFooter>
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  general: state.general,
  formRedux: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalActivity);
